/*
* Created on Jan 21, 2021
* @author: Adam Cheng <adamcheng@qnap.com>
*/
import React from 'react';
import ic_arrow_drop_down_svg from '../../../static/img/utils/ic-sort-arrow-down.svg';
import ic_arrow_drop_up_svg from '../../../static/img/utils/ic-sort-arrow-up.svg';
import ic_info_inline_svg from '../../../static/img/utils/ic-info-inline.svg';
import TableHeadFieldFilerComponent from "./TableHeadFieldFilerComponent";
import ic_sys_info_dark from "../../../static/img/utils/ic-sys-info--dark.svg";

const TableHeadFieldComponent = ({field, fieldToSort, sortOrder, toggleSortField, dispatch, state}) => {
    const toggleSort = () => {
        if (! field.isSortable) return;
        toggleSortField(field.field_id);
    }
    return (
        <div className={`thead-cell ${field.width_style}`} onClick={toggleSort}>
            <div className={field.isSortable && field.field_id === fieldToSort ? 'sort' : 'sort sort-disabled'} title={field.field_name}>
                <span className="sort-label">{field.field_name}</span>
                <span className="sort-arrow"><img src={sortOrder === '' ? ic_arrow_drop_down_svg : ic_arrow_drop_up_svg} alt="" /></span>
            </div>
            {field?.info && field?.info?.show_info &&
                <>
                    <span className="w-14px line-height-0 ml-4 tooltip">
                        <img className="w-100" src={ic_info_inline_svg}/>
                        <span className="tooltiptext">{field.info.info_text}</span>
                    </span>
                </>
            }

            {/*{field.filters && <TableHeadFieldFilerComponent field={field} dispatch={dispatch}/>}*/}
            {field.filters && <TableHeadFieldFilerComponent field={field} dispatch={dispatch} currentFilters={state?.filters?.[field.field_id] || []}/>}

        </div>
    );
};

export default TableHeadFieldComponent;